import React from "react";
import SeletorLoja from "./components/SeletorLoja";
import AppState from "./model/AppState";
import Rodape from "./components/Rodape";
import BuscaProdutos from "./components/BuscaProdutos";
import MockData from "./model/MockData";
import ConteudoModel from "./model/ConteudoModel";
import ProdutoModel from "./model/ProdutoModel";
import ReactDOM from "react-dom";
import PaginaTitulo from "./components/PaginaTitulo";
import ListaItens from "./components/ListaItens";
import QueryString from "query-string";
import LojaModel from "./model/LojaModel";
import ObaPromocaoDAO from "./dataAccess/Oba/ObaPromocaoDAO";
import WPListasDAO from "./dataAccess/WP/WPListasDAO";
import LogUtil from "./util/LogUtil";
import NavegadorUtil from "./util/NavegadorUtil";
import Carregando from "./components/Carregando";
import { RouteComponentProps } from "react-router-dom";
import LojaOfertasCacheModel from "./model/LojaOfertasCacheModel";
import ProxyCacheDAO from "./dataAccess/Proxy/ProxyCacheDados";

interface IOfertasProps extends RouteComponentProps {}

type OfertasState = {
  nome: string;
  sub: string;
  produtos: ProdutoModel[];
  conteudos: ConteudoModel[];
  carregando: boolean;
  concluido: boolean;
  mostrar: number;
};

class Ofertas extends React.Component<IOfertasProps, OfertasState> {
  constructor(props: IOfertasProps) {
    super(props);

    this.showProdutos = this.showProdutos.bind(this);
    this.showConteudos = this.showConteudos.bind(this);
    this.removeDuplicados = this.removeDuplicados.bind(this);
    this.mostrarMais = this.mostrarMais.bind(this);

    this.state = {
      nome: "Ofertas",
      sub: "",
      produtos: [],
      conteudos: [],
      carregando: false,
      concluido: false,
      mostrar: 10,
    };
  }

  showProdutos(): any {
    const prods: any = this.refs.btnProds;
    const conts: any = this.refs.btnConts;

    if (prods) {
      prods.classList.remove("active");
      prods.classList.add("active");
    }

    if (conts) {
      conts.classList.remove("active");
    }

    const prodsContainer: any = ReactDOM.findDOMNode(this.refs.prods);
    const contsContainer: any = ReactDOM.findDOMNode(this.refs.conts);
    prodsContainer.style.display = "block";
    contsContainer.style.display = "none";
  }

  showConteudos(): any {
    const prods: any = this.refs.btnProds;
    const conts: any = this.refs.btnConts;
    if (prods) {
      prods.classList.remove("active");
    }

    if (conts) {
      conts.classList.remove("active");
      conts.classList.add("active");
    }

    const prodsContainer: any = ReactDOM.findDOMNode(this.refs.prods);
    const contsContainer: any = ReactDOM.findDOMNode(this.refs.conts);
    prodsContainer.style.display = "none";
    contsContainer.style.display = "block";
  }

  componentDidMount() {
    LogUtil.logPage("Ofertas");

    this.setState({ carregando: true });

    let query: any;
    query = QueryString.parse(this.props.location.search);
    const loja: LojaModel | null = AppState.getLojaSelecionada();

    if (query.nome) {
      this.setState({
        nome: query.nome,
      });
    }

    if (query.sub) {
      this.setState({
        sub: query.sub,
      });
    }

    if (!loja) {
      NavegadorUtil.redirect("/lojas", this.props.history);
    } else {
      if (AppState.getMockData()) {
        this.setState({
          produtos: MockData.getProdutos(),
          conteudos: MockData.getConteudos(),
          carregando: false,
        });
      } else {
        ProxyCacheDAO.getInstance().getLojaCache(loja).then((produtosCache: LojaOfertasCacheModel) => {
          if (produtosCache && produtosCache.loja && produtosCache.loja.lojaId.length > 0) {
            
            const { ofertas, bemQuerer } = produtosCache;

            const produtos = this.removeDuplicados(ofertas.concat(bemQuerer));

            this.setState({
              produtos,
              carregando: false,
            });
          } else {
            ObaPromocaoDAO.getInstance()
              .getPromocao(loja)
              .then(async (r: any) => {
                let todasOfertas: ProdutoModel[] = [];
                for (const item of r) {
                  await item;
                  if (Array.isArray(item) && item.length > 0) {
                    todasOfertas = todasOfertas.concat(item);
                  }
                }
                this.setState({ produtos: todasOfertas });
              }).catch(ex => {
                this.setState({ carregando: false });
                LogUtil.logEvento('ErroCarregarPromocoes', ex);
              });
          }
          
          const allProms: any = [];

          allProms.push(WPListasDAO.getInstance()
            .getDicas(false)
            .then((dicas: ConteudoModel[]) => {
              this.setState({ conteudos: this.state.conteudos.concat(dicas) });
            }));
  
          allProms.push(WPListasDAO.getInstance()
            .getReceitas(false)
            .then((receitas: ConteudoModel[]) => {
              this.setState({ conteudos: this.state.conteudos.concat(receitas) });
            }));
  
          allProms.push(WPListasDAO.getInstance()
            .getListas(false)
            .then((listas: ConteudoModel[]) => {
              this.setState({ conteudos: this.state.conteudos.concat(listas) });
            }));

          Promise.allSettled(allProms).then(() => {
            this.setState({ concluido: true });
          });

        }).catch(() => { return new LojaOfertasCacheModel() });
      }
    }
  }

  removeDuplicados(produtos: ProdutoModel[]): ProdutoModel[] {
    const remover: string[] = [];
    const ids: string[] = [];

    produtos.map((p) => {
      ids.push(p.produtoId);
      const todos = produtos.filter(
        (outros) => p.produtoId === outros.produtoId
      );
      if (todos && todos.length > 1) {
        remover.push(p.produtoId);
      }
      return p;
    });

    remover.map((p) => {
      const todos = produtos.filter((outros) => p === outros.produtoId);
      if (todos && todos.length > 1) {
        const ultimoIndice = todos.length - 1;
        let i = 1;
        while (i <= ultimoIndice) {
          const idxProduto: number = produtos.indexOf(todos[i]);
          if (idxProduto > -1) {
            produtos.splice(idxProduto, 1);
          }
          ++i;
        }
      }
      return p;
    });

    produtos.sort((a, b) => (1-(a.precoDesconto / a.precoOriginal)) > (1-(b.precoDesconto / b.precoOriginal)) ? -1 : 1);

    return produtos;
  }

  mostrarMais() {
    this.setState({ mostrar: this.state.mostrar + 10 });
  }

  render(): any {
    let { conteudos, carregando, produtos, concluido, mostrar } = this.state;

    const produtosParcial = JSON.parse(JSON.stringify(produtos));
    produtosParcial.length = mostrar;

    return (
      <section className="category has-footer">
        <SeletorLoja loja={AppState.getLojaSelecionada()}></SeletorLoja>
        <BuscaProdutos parent={this}></BuscaProdutos>
        <PaginaTitulo titulo={"Ofertas"} subtitulo=""></PaginaTitulo>
        <ul className="main-menu">
          <li
            className="products active"
            onClick={this.showProdutos}
            ref="btnProds"
          >
            Produtos
          </li>
          <li className="inspire" onClick={this.showConteudos} ref="btnConts">
            <i className="far fa-heart"></i> Inspire-se
          </li>
        </ul>
        { produtosParcial &&
        <>
          <div ref="prods">
            <ListaItens
              produtos={produtosParcial}
              parent={this}
              carregando={carregando}
              concluido={concluido}
            ></ListaItens>
          </div>
          { mostrar < produtos.length &&
          <button onClick={this.mostrarMais} className="main-button">
            Mostrar mais
          </button>
          }
        </>
        }
        { conteudos &&
        <div ref="conts" style={{ display: "none" }}>
          <ListaItens
            conteudos={conteudos}
            parent={this}
            carregando={carregando}
            concluido={concluido}
          ></ListaItens>
        </div>
        }
        <Rodape parent={this} ativo="Ofertas"></Rodape>
        <Carregando exibir={carregando} concluido={concluido}></Carregando>
      </section>
    );
  }
}

export default Ofertas;
